import TextArea from "antd/lib/input/TextArea";
import { Form } from "antd";
import { useEffect, useMemo, useRef } from "react";
import { IMaterialGroup, IMaterialGroupFormFields } from "../type-definitions";
import { MaterialScrollList } from "../widgets";

function HasAssigneeRhsContent({
  group,
  formFieldsState
}: {
  group: IMaterialGroup;
  formFieldsState: [
    IMaterialGroupFormFields,
    React.Dispatch<React.SetStateAction<IMaterialGroupFormFields>>
  ];
}) {
  const [groupFormFields, setGroupFormFields] = formFieldsState;

  const textAreaRef = useRef<any>(null);

  useEffect(() => {
    if (textAreaRef.current) {
      const { value } = textAreaRef.current.resizableTextArea.textArea;
      textAreaRef.current.focus();
      textAreaRef.current.resizableTextArea.textArea.setSelectionRange(
        value.length,
        value.length
      );
    }
  }, []);

  const { requestAlreadySentItems, allowedToSendRequestItems } =
    group.materialsByStatus;

  const includedMaterials = useMemo(
    () => allowedToSendRequestItems.concat(requestAlreadySentItems),
    [allowedToSendRequestItems, requestAlreadySentItems]
  );

  return (
    <div>
      <div>
        <div className="text-sm font-semibold">
          {group.subcontractorCompany?.name}
        </div>
        <div className="text-xs">
          {group.assigneeUser?.first_name} {group.assigneeUser?.last_name} (
          {group.assigneeUser?.email})
        </div>
      </div>
      {includedMaterials && includedMaterials.length ? (
        <div className="mt-3">
          <div className="w-2/3">
            <Form layout="vertical">
              <Form.Item label="Add Note To Request">
                <TextArea
                  ref={textAreaRef}
                  placeholder="Add a note"
                  value={groupFormFields[group.groupId]?.note}
                  onChange={(e) => {
                    setGroupFormFields((prev) => ({
                      ...prev,
                      [group.groupId]: { note: e.target.value }
                    }));
                  }}
                  autoSize={{ minRows: 2, maxRows: 2 }}
                  allowClear
                  data-testid="notes-input"
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      ) : null}

      {includedMaterials && includedMaterials.length ? (
        <div className="mt-3.5 overflow-hidden">
          <div className="text-sm font-semibold text-color-1 mb-2">
            Selected Materials ({includedMaterials.length})
          </div>

          <div className="space-y-3 overflow-hidden">
            {allowedToSendRequestItems &&
            allowedToSendRequestItems.length > 0 ? (
              <div>
                <div className="text-xs font-semibold text-color-1 mb-2">
                  New Requests
                </div>
                <MaterialScrollList materials={allowedToSendRequestItems} />
              </div>
            ) : null}

            {requestAlreadySentItems && requestAlreadySentItems.length > 0 ? (
              <div>
                <div className="text-xs font-semibold text-color-1">
                  Recently Requested
                </div>
                <div className="text-xs font-normal text-color-2 mt-1 mb-2">
                  Request will be resent as part of this email.
                </div>
                <MaterialScrollList materials={requestAlreadySentItems} />
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default HasAssigneeRhsContent;
